// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-info-box__add-lists[data-v-0f5f1bc0]{position:absolute;top:30px;left:50%;transform:translateX(-50%);width:289px;max-height:160px;padding:19px;border-radius:5px;box-shadow:0 0 35px rgba(0,0,0,.1);background:#fff;z-index:2;overflow-y:auto}@media screen and (max-width:460px){.product-info-box__add-lists[data-v-0f5f1bc0]{left:0;transform:translateX(0)}}.individual-list__options-wrap[data-v-0f5f1bc0]{position:relative}", ""]);
// Exports
module.exports = exports;
